var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeitoresBiometricos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "leitores-biometricos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leitores-biometricos_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x37_VP4Pn.tif_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.3,56.6c-2.7,0-5.4,0-8.2,0c0-0.4,0-0.8,0-1.2c0-3.4,0-6.7,0-10.1c0-2.7-1.7-4.4-4.4-4.4 c-3.7,0-7.4,0-11.2,0v-8.1l0.1-0.1c6,0,12-0.4,17.9,0.8c4,0.8,6,5.2,5.8,9.3c0,0.2,0,0.6,0,0.6C138.3,47.9,138.3,52.2,138.3,56.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,138.3c-2.2,0-4.3-0.3-6.3-1.1c-0.5-0.2-1-0.4-1.5-0.7c-3.6-2.1-5.6-5.3-5.9-9.4 c-0.3-4.2-0.1-8.4-0.1-12.6H41c0,0.9,0,1.8,0,2.7c0,2.9,0,5.8,0,8.7c0,2.4,1.9,4.3,4.3,4.3c3.7,0,7.5,0,11.3,0v8.2h-10V138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.4,138.3c0-2.7,0-5.4,0-8.3c0.4,0,0.8,0,1.1,0c3.4,0,6.7,0,10.1,0c2.4,0,4.4-2,4.4-4.4 c0-3.7,0-7.4,0-11.2h8.2c0,4.4,0,8.8,0,13.2c-0.1,0.2,0,0.4-0.1,0.6c-1,4.6-3.9,7.8-8.3,9.5l0,0c-1.3,0.5-2.8,0.7-4.2,0.7h-11.2 C114.4,138.4,114.4,138.3,114.4,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.9,82.1c0.1-6.9,2.9-12.8,9.4-17.2c4.9-3.3,11.1-4.3,16.8-2.6c8.2,2.4,13.1,8.2,14.7,16.6 c0.5,2.5,0.4,5,0.7,7.5c0.5,3.9,1.4,7.6,2.9,11.2c1.3,3,2.9,5.8,5.5,8.1c-1.8,2.1-3.5,4.2-5.3,6.3c-2.4-2-4.2-4.3-5.7-6.9 c-3.2-5.6-4.9-11.7-5.7-18c-0.2-2.8-0.2-5.6-0.8-8.2c-1.3-5.7-6.6-9.5-12.5-9.2c-5.7,0.3-10.7,4.7-11.5,10.4 c-0.1,0.6-0.2,1.3-0.3,2C73.1,82.1,64.9,82.1,64.9,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.2,69.2l-7.6,2.8c-3.5-8.7-9.7-14.7-18.7-17.3c-8.9-2.5-17.4-1.2-25.3,4c-3.1-4.1-1.7-2.3-4.8-6.5 C80.8,39.3,111,44.3,120.2,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.6,118.6c-2.5,1.1-4.9,2.2-7.5,3.4c-0.9-2.2-1.8-4.4-2.6-6.5c-3.9-11.1-6.2-22.5-6.1-34.3 c0-6.9,2.1-13.3,5.9-19.1c0.1-0.2,0.3-0.4,0.5-0.8c2.2,1.5,4.5,3,6.7,4.5c-0.9,1.7-1.8,3.3-2.6,5.1c-2,4.5-2.5,9.2-2.2,14 c0.7,11.5,3.1,22.5,7.7,33.1C64.5,118.1,64.5,118.3,64.6,118.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.9,114c-2,1.6-4.1,3.3-6.3,5c-2.8-3.4-4.9-7.1-6.6-11c-3.5-8.1-5.3-16.5-5.7-25.3 c-0.1-1.7,0.7-3.3,2.2-4.1c1.7-1,3.3-0.6,4.7,0.6c0.9,0.8,1.3,1.9,1.4,3c0.4,8.8,2.2,17.2,6.2,25.1C97,109.6,98.5,111.7,99.9,114 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,32.7c0,2.8,0,5.5,0,8.2c-0.4,0-0.8,0-1.1,0c-3.3,0-6.7,0-10,0c-2.8,0-4.5,1.7-4.5,4.6 c0,3.3,0,6.6,0,9.9c0,0.4,0,0.7,0,1.2c-2.8,0-5.5,0-8.2,0c0-3.4,0-6.7,0-10c0-1.2,0-2.3,0.2-3.5c0.9-5.8,6-10.3,11.9-10.4 C48.8,32.7,52.6,32.7,56.6,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.8,92.8l8.1-1.2c1.5,9.6,4.3,18.8,9.5,27.2c-2.4,1.5-4.6,2.9-7,4.3C70.7,113.8,67.5,103.6,65.8,92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.2,95l-5.4,5.9c-5.1-5.4-7.3-11.8-7.4-19.1l7.9,0.5c0.6,2.4,0.9,4.7,1.7,6.9 C124.8,91.3,126.2,93.2,127.2,95z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeitoresBiometricos);
export default __webpack_public_path__ + "static/media/leitores-biometricos.72c0a47c7c695f800a5aa8e7235b7ecc.svg";
export { ForwardRef as ReactComponent };